webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(100);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(96);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 9:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  template: '<div style="display: none"><slot></slot></div>',
	
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (!this.$parent.$containerReady) {
	      throw new Error('A Layer component must be a child of LayerContainer');
	    }
	    this.$setLayer = function (layer) {
	      _this.$layer = layer;
	      _this.$parent.$containerReady.then(function (container) {
	        container.addLayer(layer);
	      });
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$layer.remove();
	  }
	};

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(54);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Layer = __webpack_require__(9);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = _leaflet2.default.Path.prototype.options;
	var styleProps = {
	  stroke: {
	    type: Boolean,
	    default: defaultOptions.stroke
	  },
	  color: {
	    type: String,
	    default: defaultOptions.color
	  },
	  weight: {
	    type: Number,
	    default: defaultOptions.weight
	  },
	  opacity: {
	    type: Number,
	    default: defaultOptions.opacity
	  },
	  lineCap: {
	    type: String,
	    default: defaultOptions.lineCap
	  },
	  lineJoin: {
	    type: String,
	    default: defaultOptions.lineJoin
	  },
	  dashArray: {
	    type: String,
	    default: defaultOptions.dashArray
	  },
	  fill: {
	    type: Boolean,
	    default: defaultOptions.fill
	  },
	  fillColor: {
	    type: String,
	    default: defaultOptions.fillColor
	  },
	  fillOpacity: {
	    type: Number,
	    default: defaultOptions.fillOpacity
	  },
	  fillRule: {
	    type: String,
	    default: defaultOptions.fillRule
	  }
	};
	
	var mapEvents = ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'add', 'remove', 'popupopen', 'popupclose'];
	
	exports.default = {
	
	  mixins: [_Layer2.default],
	
	  props: (0, _extends3.default)({}, styleProps),
	
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    this.$setPath = function (path) {
	      _this.$path = path;
	      _this.$setLayer(path);
	    };
	  },
	
	
	  computed: {
	    pathStyle: function pathStyle() {
	      var pathStyle = {};
	      for (var prop in styleProps) {
	        pathStyle[prop] = this[prop];
	      }
	      return pathStyle;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    mapEvents.forEach(function (eventName) {
	      return _this2.$path.on(eventName, function (ev) {
	        return _this2.$emit(eventName, ev);
	      });
	    });
	
	    var _loop = function _loop(prop) {
	      _this2.$watch(prop, function (newValue, oldValue) {
	        if (newValue !== oldValue) {
	          _this2.$path.setStyle((0, _defineProperty3.default)({}, prop, newValue));
	        }
	      });
	    };
	
	    for (var prop in styleProps) {
	      _loop(prop);
	    }
	  }
	};

/***/ },

/***/ 26:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(53);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    this.$containerReady = new _promise2.default(function (resolve) {
	      _this.$setContainer = function (container) {
	        if (!container.addLayer) {
	          throw new Error('A LayerContainer component needs an addLayer method');
	        }
	        _this.$container = container;
	        resolve(container);
	      };
	    });
	  }
	};

/***/ },

/***/ 40:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Path = __webpack_require__(12);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = _leaflet2.default.CircleMarker.prototype.options;
	
	exports.default = {
	
	  mixins: [_Path2.default],
	
	  props: {
	    position: {
	      type: Object,
	      required: true
	    },
	    radius: {
	      type: Number,
	      default: defaultOptions.radius
	    },
	    fill: {
	      type: Boolean,
	      default: defaultOptions.fill
	    }
	  },
	
	  created: function created() {
	    this.$circle = _leaflet2.default.circle(this.position, (0, _extends3.default)({
	      radius: this.radius
	    }, this.pathStyle));
	    this.$setPath(this.$circle);
	  },
	
	
	  watch: {
	    position: function position(_position) {
	      this.$circle.setLatLng(_position);
	    },
	    radius: function radius(_radius) {
	      this.$circle.setRadius(_radius);
	    }
	  }
	
	};

/***/ },

/***/ 41:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Layer = __webpack_require__(9);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  mixins: [_Layer2.default],
	
	  props: {
	    data: {
	      type: Object,
	      required: true
	    },
	    featureStyle: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	
	  created: function created() {
	    this.$geoJson = _leaflet2.default.geoJSON(this.data, {
	      style: this.featureStyle
	    });
	    this.$setLayer(this.$geoJson);
	  },
	
	
	  watch: {
	    featureStyle: function featureStyle(_featureStyle) {
	      this.$geoJson.setStyle(_featureStyle);
	    },
	    data: function data(_data) {
	      this.$geoJson.clearLayers();
	      this.$geoJson.addData(_data);
	    }
	  }
	};

/***/ },

/***/ 42:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Layer = __webpack_require__(9);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LayerContainer = __webpack_require__(26);
	
	var _LayerContainer2 = _interopRequireDefault(_LayerContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  mixins: [_LayerContainer2.default, _Layer2.default],
	
	  created: function created() {
	    this.$layerGroup = _leaflet2.default.layerGroup();
	    this.$setContainer(this.$layerGroup);
	    this.$setLayer(this.$layerGroup);
	  }
	};

/***/ },

/***/ 43:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Layer = __webpack_require__(9);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	delete _leaflet2.default.Icon.Default.prototype._getIconUrl;
	_leaflet2.default.Icon.Default.mergeOptions({
	  iconRetinaUrl: __webpack_require__(93),
	  iconUrl: __webpack_require__(94),
	  shadowUrl: __webpack_require__(95)
	});
	
	exports.default = {
	
	  mixins: [_Layer2.default],
	
	  props: {
	    position: {
	      type: Object,
	      required: true
	    },
	    icon: {
	      type: _leaflet2.default.Icon,
	      default: function _default() {
	        return new _leaflet2.default.Icon.Default();
	      }
	    }
	  },
	
	  watch: {
	    position: function position(_position) {
	      this.$marker.setLatLng(_position);
	    },
	    icon: function icon(_icon) {
	      this.$marker.setIcon(_icon);
	    }
	  },
	
	  created: function created() {
	    this.$marker = _leaflet2.default.marker(this.position, {
	      icon: this.icon
	    });
	    this.$setLayer(this.$marker);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var mapEvents = ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'dragstart', 'drag', 'dragend', 'move', 'add', 'remove', 'popupopen', 'popupopen'];
	    mapEvents.forEach(function (eventName) {
	      return _this.$marker.on(eventName, function (ev) {
	        return _this.$emit(eventName, ev);
	      });
	    });
	  }
	};

/***/ },

/***/ 44:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Path = __webpack_require__(12);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = _leaflet2.default.Polygon.prototype.options;
	
	exports.default = {
	
	  mixins: [_Path2.default],
	
	  props: {
	    latlngs: {
	      type: Array,
	      required: true
	    },
	    fill: {
	      type: Boolean,
	      default: defaultOptions.fill
	    }
	  },
	
	  created: function created() {
	    this.$polygon = _leaflet2.default.polygon(this.latlngs, (0, _extends3.default)({}, this.pathStyle));
	    this.$setPath(this.$polygon);
	  },
	
	
	  watch: {
	    latlngs: function latlngs(_latlngs) {
	      this.$polygon.setLatLngs(_latlngs);
	    }
	  }
	
	};

/***/ },

/***/ 45:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Path = __webpack_require__(12);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  mixins: [_Path2.default],
	
	  props: {
	    latlngs: {
	      type: Array,
	      required: true
	    }
	  },
	
	  created: function created() {
	    this.$polyline = _leaflet2.default.polyline(this.latlngs, (0, _extends3.default)({}, this.pathStyle));
	    this.$setPath(this.$polyline);
	  },
	
	
	  watch: {
	    latlngs: function latlngs(_latlngs) {
	      this.$polyline.setLatLngs(_latlngs);
	    }
	  }
	
	};

/***/ },

/***/ 46:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Path = __webpack_require__(12);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = _leaflet2.default.Polygon.prototype.options;
	
	exports.default = {
	
	  mixins: [_Path2.default],
	
	  props: {
	    bounds: {
	      type: Array,
	      required: true
	    },
	    fill: {
	      type: Boolean,
	      default: defaultOptions.fill
	    }
	  },
	
	  created: function created() {
	    this.$rectangle = _leaflet2.default.rectangle(this.bounds, (0, _extends3.default)({}, this.pathStyle));
	    this.$setPath(this.$rectangle);
	  },
	
	
	  watch: {
	    bounds: function bounds(_bounds) {
	      this.$rectangle.setBounds(_bounds);
	    }
	  }
	
	};

/***/ },

/***/ 47:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _Layer = __webpack_require__(9);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  mixins: [_Layer2.default],
	
	  props: {
	    url: {
	      type: String,
	      required: true
	    },
	    attribution: {
	      type: String,
	      default: ''
	    }
	  },
	
	  created: function created() {
	    this.$tileLayer = _leaflet2.default.tileLayer(this.url, {
	      attribution: this.attribution
	    });
	    this.$setLayer(this.$tileLayer);
	  }
	};

/***/ },

/***/ 48:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TileLayer = exports.Rectangle = exports.Polygon = exports.Polyline = exports.Marker = exports.Map = exports.LayerGroup = exports.GeoJson = exports.Circle = undefined;
	
	var _Circle = __webpack_require__(40);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _GeoJson = __webpack_require__(41);
	
	var _GeoJson2 = _interopRequireDefault(_GeoJson);
	
	var _LayerGroup = __webpack_require__(42);
	
	var _LayerGroup2 = _interopRequireDefault(_LayerGroup);
	
	var _Map = __webpack_require__(97);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Marker = __webpack_require__(43);
	
	var _Marker2 = _interopRequireDefault(_Marker);
	
	var _Polygon = __webpack_require__(44);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Polyline = __webpack_require__(45);
	
	var _Polyline2 = _interopRequireDefault(_Polyline);
	
	var _Rectangle = __webpack_require__(46);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _TileLayer = __webpack_require__(47);
	
	var _TileLayer2 = _interopRequireDefault(_TileLayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Circle = _Circle2.default;
	exports.GeoJson = _GeoJson2.default;
	exports.LayerGroup = _LayerGroup2.default;
	exports.Map = _Map2.default;
	exports.Marker = _Marker2.default;
	exports.Polyline = _Polyline2.default;
	exports.Polygon = _Polygon2.default;
	exports.Rectangle = _Rectangle2.default;
	exports.TileLayer = _TileLayer2.default;

/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _components = __webpack_require__(48);
	
	var components = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Vmap: components.Map,
	    VmapMarker: components.Marker,
	    VmapGeoJson: components.GeoJson,
	    VmapCircle: components.Circle,
	    VmapLayerGroup: components.LayerGroup,
	    VmapPolyline: components.Polyline,
	    VmapRectangle: components.Rectangle,
	    VmapTileLayer: components.TileLayer
	  },
	  data: function data() {
	    return {
	      lat: 49.611,
	      lng: 6.13,
	      zoom: 13,
	      markers: [{ lat: 49.611, lng: 6.13 }, { lat: 49.62, lng: 6.118 }],
	      newMarker: { lat: '', lng: '' },
	      geoJson: {
	        type: 'Polygon',
	        coordinates: [[[6.114921569824219, 49.612378400270195], [6.125907897949219, 49.618495606374275], [6.139812469482421, 49.617272226578514], [6.141357421875, 49.61148856087291], [6.14032745361328, 49.60626042633693], [6.126594543457031, 49.60247802203419], [6.113376617431641, 49.60715036117516], [6.114921569824219, 49.612378400270195]]]
	      },
	      geoJsonStyle: function geoJsonStyle() {
	        return {
	          color: '#933'
	        };
	      }
	    };
	  },
	
	  computed: {
	    position: function position() {
	      return {
	        lat: this.lat,
	        lng: this.lng
	      };
	    }
	  },
	  methods: {
	    onZoom: function onZoom(data) {
	      this.zoom = data.zoom;
	    },
	    onMove: function onMove(data) {
	      this.lat = data.position.lat;
	      this.lng = data.position.lng;
	    },
	    removeMarker: function removeMarker(index) {
	      this.markers.splice(index, 1);
	    },
	    addMarker: function addMarker() {
	      this.markers.push(this.newMarker);
	      this.newMarker = { lat: '', lng: '' };
	    },
	    addMarkerAtMapPosition: function addMarkerAtMapPosition() {
	      this.markers.push({
	        lat: this.lat,
	        lng: this.lng
	      });
	    },
	    updateMarkerLat: function updateMarkerLat(index, event) {
	      this.markers.splice(index, 1, (0, _extends3.default)({}, this.markers[index], {
	        lat: event.target.value
	      }));
	    },
	    updateMarkerLng: function updateMarkerLng(index, event) {
	      this.markers.splice(index, 1, (0, _extends3.default)({}, this.markers[index], {
	        lng: event.target.value
	      }));
	    }
	  }
	};

/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(3);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _LayerContainer = __webpack_require__(26);
	
	var _LayerContainer2 = _interopRequireDefault(_LayerContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  mixins: [_LayerContainer2.default],
	
	  props: {
	    position: {
	      type: Object,
	      required: true
	    },
	
	    zoom: {
	      type: Number,
	      default: 13
	    },
	
	    minZoom: {
	      type: Number
	    },
	
	    maxZoom: {
	      type: Number
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$map = _leaflet2.default.map(this.$refs.map, {
	      center: this.position,
	      zoom: this.zoom,
	      minZoom: this.minZoom,
	      maxZoom: this.maxZoom
	    });
	
	    var mapEvents = ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove', 'contextmenu', 'focus', 'blur', 'preclick', 'load', 'unload', 'viewreset', 'movestart', 'dragstart', 'drag', 'dragend', 'zoomstart', 'zoomlevelschange', 'resize', 'autopanstart', 'layeradd', 'layerremove', 'baselayerchange', 'overlayadd', 'overlayremove', 'locationfound', 'locationerror', 'popupopen', 'popupclose'];
	    mapEvents.forEach(function (eventName) {
	      return _this.$map.on(eventName, function (ev) {
	        return _this.$emit(eventName, ev);
	      });
	    });
	
	    this.$map.on('zoom', function (ev) {
	      return _this.$emit('zoom', (0, _extends3.default)({}, ev, {
	        zoom: _this.$map.getZoom()
	      }));
	    });
	    this.$map.on('zoomend', function (ev) {
	      return _this.$emit('zoomend', (0, _extends3.default)({}, ev, {
	        zoom: _this.$map.getZoom()
	      }));
	    });
	    this.$map.on('move', function (ev) {
	      return _this.$emit('move', (0, _extends3.default)({}, ev, {
	        position: _this.$map.getCenter()
	      }));
	    });
	    this.$map.on('movend', function (ev) {
	      return _this.$emit('moveend', (0, _extends3.default)({}, ev, {
	        position: _this.$map.getCenter()
	      }));
	    });
	
	    this.$setContainer(this.$map);
	  },
	
	
	  watch: {
	    zoom: function zoom(_zoom) {
	      this.$map.setZoom(_zoom);
	    },
	    minZoom: function minZoom(_minZoom) {
	      this.$map.setMinZoom(_minZoom);
	    },
	    maxZoom: function maxZoom(_maxZoom) {
	      this.$map.setMaxZoom(_maxZoom);
	    },
	    position: function position(_position) {
	      this.$map.panTo({
	        lat: _position.lat,
	        lng: _position.lng
	      });
	    }
	  }
	
	};

/***/ },

/***/ 92:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 93:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 94:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ },

/***/ 95:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ },

/***/ 96:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(98)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 97:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(92)
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(99)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 98:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('vmap', {
	    attrs: {
	      "position": _vm.position,
	      "zoom": _vm.zoom
	    },
	    on: {
	      "zoom": _vm.onZoom,
	      "move": _vm.onMove
	    }
	  }, [_c('vmap-tile-layer', {
	    attrs: {
	      "url": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	      "attribution": "&copy; <a href=&#34;http://osm.org/copyright&#34;>OpenStreetMap</a> contributors uga uga"
	    }
	  }), _vm._v(" "), _vm._l((_vm.markers), function(markerPosition) {
	    return _c('vmap-marker', {
	      attrs: {
	        "position": markerPosition
	      }
	    })
	  }), _vm._v(" "), _c('vmap-layer-group', [_c('vmap-geo-json', {
	    attrs: {
	      "data": _vm.geoJson,
	      "feature-style": _vm.geoJsonStyle
	    }
	  }), _vm._v(" "), _c('vmap-circle', {
	    attrs: {
	      "position": {
	        lat: 49.614,
	        lng: 6.084
	      },
	      "radius": 1000,
	      "stroke": true,
	      "color": "#990"
	    }
	  })]), _vm._v(" "), _c('vmap-rectangle', {
	    attrs: {
	      "bounds": [{
	        lat: 49.614,
	        lng: 6.084
	      }, {
	        lat: 49.62,
	        lng: 6.118
	      }]
	    }
	  }), _vm._v(" "), _c('vmap-polyline', {
	    attrs: {
	      "latlngs": [{
	        lat: 49.614,
	        lng: 6.084
	      }, {
	        lat: 49.62,
	        lng: 6.118
	      }]
	    }
	  })], true), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Map")]), _vm._v(" "), _c('div', [_vm._v("\n      Latitude: "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lat),
	      expression: "lat"
	    }],
	    attrs: {
	      "type": "number",
	      "step": "any"
	    },
	    domProps: {
	      "value": _vm._s(_vm.lat)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lat = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v("\n      Longitude: "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lng),
	      expression: "lng"
	    }],
	    attrs: {
	      "type": "number",
	      "step": "any"
	    },
	    domProps: {
	      "value": _vm._s(_vm.lng)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lng = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.addMarkerAtMapPosition
	    }
	  }, [_vm._v("Add Marker")])]), _vm._v(" "), _c('div', [_vm._v("\n      Zoom:\n      "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zoom),
	      expression: "zoom"
	    }],
	    attrs: {
	      "type": "number",
	      "step": "any"
	    },
	    domProps: {
	      "value": _vm._s(_vm.zoom)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.zoom = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Markers")]), _vm._v(" "), _vm._l((_vm.markers), function(marker, index) {
	    return _c('div', [_vm._v("\n      Latitude: "), _c('input', {
	      attrs: {
	        "type": "number",
	        "step": "any"
	      },
	      domProps: {
	        "value": marker.lat
	      },
	      on: {
	        "input": function($event) {
	          _vm.updateMarkerLat(index, $event)
	        }
	      }
	    }), _vm._v("\n      Longitude: "), _c('input', {
	      attrs: {
	        "type": "number",
	        "step": "any"
	      },
	      domProps: {
	        "value": marker.lng
	      },
	      on: {
	        "input": function($event) {
	          _vm.updateMarkerLng(index, $event)
	        }
	      }
	    }), _vm._v(" "), _c('button', {
	      on: {
	        "click": function($event) {
	          _vm.removeMarker(index)
	        }
	      }
	    }, [_vm._v("Remove")])])
	  }), _vm._v(" "), _c('div', [_vm._v("\n      Latitude: "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMarker.lat),
	      expression: "newMarker.lat"
	    }],
	    attrs: {
	      "type": "number",
	      "step": "any"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newMarker.lat)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMarker.lat = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v("\n      Longitude: "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMarker.lng),
	      expression: "newMarker.lng"
	    }],
	    attrs: {
	      "type": "number",
	      "step": "any"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newMarker.lng)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMarker.lng = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.addMarker
	    }
	  }, [_vm._v("Add")])])], true)])
	},staticRenderFns: []}

/***/ },

/***/ 99:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vue-map"
	  }, [_c('div', {
	    ref: "map",
	    staticClass: "map-container"
	  }), _vm._v(" "), _vm._t("default")], true)
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.fff488cf0e431180efe8.js